import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex } from 'nallian-shared-ui/lib/components';
import { Text, ErrorIcon } from 'nallian-shared-ui/lib/layout/styles';

const InvitationError = () => {
  const { t } = useTranslation();

  return (
    <Flex direction="column" alignItems="center">
      <ErrorIcon name="close" color="white" size="large" />
      <Flex margin="1rem 0 0">
        <Text>
          <span>{t('invalidInvitation1')}&nbsp;</span>
          <span>{t('invalidInvitation2')}</span>
        </Text>
      </Flex>
    </Flex>
  );
};

export default InvitationError;
